var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHomeKnow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "icon-home-know_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38358F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC1FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "icon-home-know_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38358F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC1FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 59.5,
    cy: 59.5,
    r: 59.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#icon-home-know_svg__a)",
    strokeWidth: 2,
    d: "M34 27h51v64H34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 48a7 7 0 110-14 7 7 0 010 14zm-7.11 9h39.706H39.89zm-.265 5h39.706-39.706zm0 6h39.706-39.706zm0 5h39.706-39.706z",
    stroke: "url(#icon-home-know_svg__b)",
    strokeWidth: 2
  }))));
}

export default SvgIconHomeKnow;